<template>
  <div class="installation">
    <div class="container">
      <img class="ios-btn" src="@/assets/images/installation-ios.svg" alt="">
      <h3 class="installation-title h3">{{ $t('installation.title') }}</h3>
      <p
        v-if="platform === 'ios'"
        class="installation-text"
        v-html="$t('installation.ios')"
      >
      </p>

      <p
        v-if="platform === 'android'"
        class="installation-text"
        v-html="$t('installation.android')"
      >
      </p>
      <btn
          v-if="deferredPrompt"
          @click="$emit('install')">
          {{ $t('installation.cta') }}
      </btn>

      <button
        class="installation-close"
        @click="$emit('close')"
      >
        <sprite
          :type="'close'"
          :width="12"
          :height="12"
        />
      </button>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';
import Btn from '@/components/components/Btn.vue';

export default {
  components: {
    Sprite,
    Btn
  },
  props: {
    platform: {
      type: String,
      required: true
    },
    deferredPrompt: {
      type: Event
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.installation {
  @include position(fixed, null null 0 0);
  @include padding(20px null);
  @include size(100%, auto);
  z-index: 1001;
  background-color: rgba($white, .9);
  backdrop-filter: blur(20px);

  .ios-btn {
    display: none;
  }

  .container {
    @include padding(null 16px);
  }

  &-title {
    @include margin(null null 15px);
    color: $primary;
  }

  &-text {
    color: $primary;

    img {
      display: inline-block;
      vertical-align: middle;
    }

    + .btn {
      @include margin(15px null null);
    }
  }

  &-close {
    @include position(absolute, 0 0 null null);
    @include padding(22px 20px 24px 24px);

    .svg {
      display: block;
      fill: $primary;
    }
  }
}
</style>
